import {
  Component
} from '@angular/core';

@Component({
  selector: 'svg-icon-deviceId',
  templateUrl: './svg-icon-deviceId.component.html',
  styleUrls: ['../svg-icon-colors.scss'],
})
export class SvgIconDeviceId {
}
